import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Market.css";
const Markets = () => {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);
    const [lang, setLang] = useState("En");
    useEffect(() => {
        if (localStorage.getItem("language") === "En") {
            setLang("En");
        } else if (localStorage.getItem("language") === "Fr") {
            setLang("Fr");
        }
    }, []);
    return (
        <section
            class="section-empty"
            style={{ backgroundColor: "#242424", padding: "70px 0px" }}
        >
            <div class="container content">
                <div
                    class="text-center top-text"
                    style={{
                        marginBottom: "30px",
                        transform: "translateY(20px)",
                    }}
                >
                    <h1 style={{ fontSize: "48px" }}>
                        <span>
                            {lang === "Fr" ? `BUREAUX` : `International`}{" "}
                        </span>{" "}
                        {lang == "Fr" ? `INTERNATIONAUX` : `offices`}
                    </h1>
                </div>
                <div class="row" style={{ transform: "translateY(40px)" }}>
                    <div
                        class="col-md-7 col-sm-6"
                        data-aos="fade-right"
                        data-aos-offset="300"
                        data-aos-easing="ease-in-sine"
                    >
                        <img src={require("../../Assets/chart.png")} alt="" />
                    </div>
                    <div class="col-md-1 hidden-sm"></div>
                    <div class="col-md-4 col-sm-6">
                        <div class="title-base text-left">
                            <hr style={{ borderTop: "6px solid #daa520" }} />
                            <h2>
                                {lang === "Fr"
                                    ? `NOUS SOMMES DANS LE MONDE ENTIER`
                                    : `We are worldwide`}
                            </h2>
                            {/* <p>International offices</p> */}
                        </div>
                        <ul
                            class="list-texts list-texts-justified"
                            data-anima="fade-bottom"
                            data-timeline="asc"
                        >
                            <li class="anima" data-aos="fade-up">
                                <b>{lang === "Fr" ? `Londres` : `London`}</b>{" "}
                                <span>
                                    {lang === "Fr"
                                        ? `Royaume-Uni`
                                        : `United Kingdom`}
                                </span>
                            </li>
                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="300"
                            >
                                <b>Phoenix</b>{" "}
                                <span>
                                    {lang === "Fr"
                                        ? `États-Unis`
                                        : `United States`}
                                </span>
                            </li>
                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                <b>Toronto</b> <span>Canada</span>
                            </li>
                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="400"
                            >
                                <b>Dubai</b>{" "}
                                <span>
                                    {lang === "Fr"
                                        ? `Émirats arabes unis`
                                        : `United Arab Emirates`}
                                </span>
                            </li>
                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="500"
                            >
                                <b>Hong Kong</b>{" "}
                                <span>
                                    {lang === "Fr"
                                        ? `République populaire de Chine`
                                        : `People's Republic of China`}
                                </span>
                            </li>
                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="600"
                            >
                                <b>
                                    {lang === "Fr" ? `Singapour` : `Singapore`}
                                </b>{" "}
                                <span>
                                    {lang === "Fr"
                                        ? `République de Singapour`
                                        : `Republic of Singapore`}
                                </span>
                            </li>
                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="700"
                            >
                                <b>{lang === "Fr" ? `Yaoundé` : `Yaounde`}</b>{" "}
                                <span>
                                    {lang === "Fr" ? `Cameroun` : `Cameroon`}
                                </span>
                            </li>
                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="800"
                            >
                                <b>{lang === "Fr" ? `Nairobi` : `Nairobi`}</b>
                                <span>{lang === "Fr" ? `Kenya` : `Kenya`}</span>
                            </li>

                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="900"
                            >
                                <b>Kampala</b>{" "}
                                <span>
                                    {lang === "Fr" ? `Ouganda` : `Uganda`}
                                </span>
                            </li>
                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="1000"
                            >
                                <b>
                                    {lang === "Fr"
                                        ? `La Ville Libre`
                                        : `FreeTown`}
                                </b>{" "}
                                <span>
                                    {lang === "Fr"
                                        ? `Republic of Sierra Leone`
                                        : `Sierra Leone`}
                                </span>
                            </li>
                            <li
                                class="anima"
                                data-aos="fade-up"
                                data-aos-delay="1100"
                            >
                                <b>Dodoma</b>{" "}
                                <span>
                                    {lang === "Fr" ? `Tanzanie` : `Tanzania`}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Markets;
